import Vue from 'vue';
import axios from 'axios';
import QS from 'qs';
import store from './store/index';
import router from './router';

import {
  Message
} from 'element-ui';
// Vue.use(Message);
//设置请求超时
axios.defaults.timeout = 5000;
// 环境的切换
// if (process.env.NODE_ENV == 'development') {
// axios.defaults.baseURL = '/msgplt';
// axios.defaults.baseURL = 'https://xcx.fonery.cn/msgplt/'; //原线上
axios.defaults.baseURL = 'https://xyqyfw.com/msgplt/'; //线上

// }
// else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = 'https://www.ceshi.com';
// }
// else if (process.env.NODE_ENV == 'production') {
//     axios.defaults.baseURL = 'https://www.production.com';
// }

//http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = ''; //注意使用的时候需要引入cookie方法，推荐js-cookie
    // config.data = JSON.stringify(config.data);
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token')
    }

    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Token': token
    }

    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      switch (response.data.code) {
        case 403:
          Message({
            message: '登录过期，请重新登录',
            type: 'warning'
          });
          // 清除token
          localStorage.clear();
          store.commit('changeIsLogin', false);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;
          // 1请求返回错误信息
        case 1:
          if (response.data.msg != '未收藏过') {
            Message({
              message: response.data.msg,
              type: 'warning'
            });
          }
          break;
          //请求成功
        default:
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    const {
      response
    } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      if (error.response.status) {
        switch (error.response.code) {
          // 401: 未登录
          // 未登录则跳转登录页面，并携带当前页面的路径
          // 在登录成功后返回当前页面，这一步需要在登录页操作。
          case 401:
            router.replace({
              path: '/',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
            break;

            // 403 token过期
            // 登录过期对用户进行提示
            // 清除本地token和清空vuex中token对象
            // 跳转登录页面
          case 403:
            Message({
              message: '登录过期，请重新登录',
              type: 'warning'
            });
            // 清除token
            localStorage.clear();
            store.commit('changeIsLogin', false);
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            setTimeout(() => {
              router.replace({
                path: '/',
                query: {
                  redirect: router.currentRoute.fullPath
                }
              });
            }, 1000);
            break;

            // 404请求不存在
          case 404:
            Message({
              message: '网络请求不存在',
              type: 'warning'
            });
            break;
            // 其他错误，直接抛出错误提示
          default:
            Message({
              message: error.response.msg,
              type: 'warning'
            });
        }
        return Promise.reject(error.response);
      }
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      store.commit('changeNetwork', false);
    }
  });

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params))
      // axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/http.js